import axios from 'axios';
import { version } from '../../package.json';

const api = axios.create({
  baseURL: process.env.VITE_API_BASE_URL,
  headers: {
    'Access-Control-Allow-Origin': 'true',
    'Content-Type': 'application/json',
    'app-version': version,
  },
});

api.interceptors.response.use(
  (response) => {
    if (response.status === 204) {
      return response;
    }

    // cubre el caso de un download de un archivo
    if (response.status === 200 && response.request.responseType === 'blob') {
      return response;
    }
    return response;
  },
  (error) => {
    if (!error.status && !error.response) {
      window.location.reload();
    }
    return error.response;
  },
);

export const remove = (path: any, body?: object) =>
  api.delete(path, { params: body });

export const get = (path: any, query?: object) =>
  api.get(path, { params: query });

export const post = (path: any, body: object) => api.post(path, body);

export const put = (path: any, body: object, query?: object) =>
  api.put(path, body, query);

export const patch = (path: any, body: object, query?: object) =>
  api.patch(path, body, query);

export const setCountryCode = (code: string): void => {
  api.defaults.headers.common['Country-Code'] = code;
};

export default api;
